import React from 'react'

const EditSuggestedAdminOffers = () => {
    return (
        <div>EditSuggestedAdminOffers</div>
    )
}

export default EditSuggestedAdminOffers